import { FormOption } from 'types';

export const EMPTY_OPTION: FormOption = {
  label: '',
  value: '',
};
